export default __webpack_public_path__ + "static/media/coverPhoto.407d1347.jpeg";